
import { useDialogStore } from '@/store/dialogStore'
import { Transition, computed, onUnmounted, watch } from 'vue'

export default {
  name: 'DialogVue',
  components: {
    Transition
  },
  setup () {
    const dialog = useDialogStore()

    const isOpen = computed(() => dialog.type !== 'none')

    const onConfirm = () => dialog.resolve(true)
    const onCancel = () => dialog.resolve(false)

    onUnmounted(() => {
      document.body.style.overflow = 'initial'
    })

    watch(isOpen, () => {
      if (isOpen.value) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'initial'
      }
    })

    return {
      dialog,
      isOpen,
      onConfirm,
      onCancel
    }
  }
}
